<template>
  <request-form mode="Confirm" :can-back="true" @submit.prevent="doEditor" @back="toEditor">
    <date-browse-item label="依頼日" :value="requestAt" />
    <text-browse-item label="依頼物件名・棟名" :value="building.name" />
    <text-browse-item label="依頼物件名・棟名（カナ）" :value="building.name_kana" />
    <text-browse-item label="依頼物件住戸番号" :value="buildingHouseNumber" />
    <text-browse-item label="所有者" :value="owner_name" />
    <text-browse-item label="依頼物件郵便番号" :value="building.postal_code" />
    <text-browse-item label="依頼物件住所" :value="building.address" />
    <div v-show="requiredDocumentType !== $constant.DOCUMENT_TYPE.HIDDEN">
      <text-browse-item label="依頼主確認書類" :value="requiredDocument" />
    </div>
    <text-browse-item label="発行書類" :value="issueDocumentName" />
    <text-browse-item label="手数料の支払方法" :value="paymentMethodName" />
    <text-browse-with-unit-item label="請求金額" :value="billingPrice" unit="円" />
    <textarea-browse-item label="備考" :value="note" />
    <text-browse-item v-if="isOwner" label="依頼者住所" :value="ownerAddress" />
    <text-browse-item v-if="!isOwner" label="会社名" :value="company.name" />
    <text-browse-item v-if="!isOwner" label="会社住所" :value="companyAddress" />
    <textarea-browse-item label="連絡先" :value="contact" />
    <licence-browse-item v-if="!isOwner" label="免許番号" :type="company.licence_type" :number="company.licence_number" :update="company.licence_update" />
  </request-form>
</template>

<script>
import {mapState, mapGetters, mapMutations} from "vuex";
import {convertPrefectureCodeToName} from '@/constants/prefecture';
import {convertPaymentMethodToName} from '@/constants/payment_method';
import RequestForm from '@/views/templates/forms/RequestForm';
import DateBrowseItem from "@/views/molecules/browseItems/DateBrowseItem";
import TextBrowseItem from "@/views/molecules/browseItems/TextBrowseItem";
import TextBrowseWithUnitItem from '@/views/molecules/browseItems/TextBrowseWithUnitItem';
import TextareaBrowseItem from "@/views/molecules/browseItems/TextareaBrowseItem";
import LicenceBrowseItem from "@/views/molecules/browseItems/LicenceBrowseItem";

export default {
  name: 'IssuanceRequestEditorConfirm',
  components: {
    RequestForm,
    DateBrowseItem,
    TextBrowseItem,
    TextBrowseWithUnitItem,
    TextareaBrowseItem,
    LicenceBrowseItem,
  },
  inject: [
    '$constant',
  ],
  computed: {
    ...mapState('issuance_request_form', {
      requestAt: state => state.data.request_at,
      building: state => state.data.building,
      buildingHouseNumber: state => state.data.building_house_number,
      owner_name: state => state.data.owner_name,
      note: state => state.data.note,
      contact: state => state.data.contact,
      payment_method_code: state => state.data.payment_method,
      requiredDocumentType: state => state.data.required_document_type,
      ownerAddress: state => state.data.owner_address,
    }),
    ...mapState('account', {
      isGuest: state => state.is_guest,
      company: state => state.company,
      guestType: state => state.guest_type,
    }),
    ...mapGetters('issuance_request_form', [
      'requiredDocumentTypeName',
      'requiredDocumentUploadFileName',
      'issueDocumentName',
      'billingPrice',
    ]),
    requiredDocument() {
      return this.requiredDocumentTypeName + ' ' + this.requiredDocumentUploadFileName;
    },
    companyAddress() {
      return convertPrefectureCodeToName(this.company.prefecture_code) + this.company.address1 + (this.company.address2 ?? '');
    },
    editorRouteName() {
      return this.isGuest ? 'GuestIssuanceRequestEditor' : 'IssuanceRequestEditor';
    },
    acceptedRouteName() {
      return this.isGuest ? 'GuestIssuanceRequestEditorAccepted' : 'IssuanceRequestEditorAccepted';
    },
    paymentMethodName() {
      return convertPaymentMethodToName(this.payment_method_code);
    },
    isOwner() {
      return this.guestType === this.$constant.GUEST_TYPE.OWNER.code;
    },
  },
  beforeRouteLeave(to) {
    if (!to.name.match(/^((Guest)?IssuanceRequestEditor|(Guest)?IssuanceRequestEditorAccepted)$/)) {
      // 遷移先が想定された場所以外なら入力内容をリセットする
      this.resetData();
    }
  },
  methods: {
    ...mapMutations('issuance_request_form', [
      'resetData',
    ]),
    ...mapMutations('account', [
      'setGuestIssuanceRequestId',
    ]),
    async doEditor() {
      if (this.isGuest){
        await this.$store.dispatch('account/authGuest', {
          access_key: sessionStorage.getItem('accessKey')
        }).catch((reason) => this.$root.failApi(reason));
      }
      this.$store.dispatch('issuance_request_form/update').then(() => {
        this.$router.push({name: this.acceptedRouteName});
      }).catch((reason) => {
        if (reason?.handled) {
          this.$router.push({name: this.editorRouteName});
        } else {
          this.$root.failApi();
        }
      });
    },
    toEditor() {
      this.$router.push({name: this.editorRouteName, params: {id: this.$route.params.id}});
    },
  }
}
</script>
